import { SesamiSlotObject } from '@/@types/calendar';
import CalendarTimeSlot from './CalendarTimeSlot';
import { useAtomValue, useAtom } from 'jotai';
import { calendarConfigAtom, selectedDayAtom, selectedTimeSlotAtom } from './calendar-atoms';
import { format } from 'date-fns/format';

type Props = {
  day: Date;
  slots: SesamiSlotObject['slots'];
};

function CalendarTimeSlots({ day, slots }: Props) {
  const { labels } = useAtomValue(calendarConfigAtom);

  const [selectedDay, setSelectedDay] = useAtom(selectedDayAtom);
  const selectedTimeSlot = useAtomValue(selectedTimeSlotAtom);

  return (
    <>
      <div className="medispa-calendar_timeslots-head" style={{ display: 'flex' }}>
        <button type="button" id="medispa-calendar_back" onClick={() => setSelectedDay(null)}>
          {labels.back}
        </button>
        <h6 className="medispa-calendar_timeslots-current">{format(day, 'EEEE, MMMM dd')}</h6>
      </div>

      <div className="medispa-calendar_timeslots" style={{ display: 'grid' }}>
        {slots.map((slot) => (
          <CalendarTimeSlot key={slot.startTime} day={day} slot={slot} />
        ))}

        <span className="reservation-time-reminder">{labels.reservation_time}</span>
      </div>
    </>
  );
}

export default CalendarTimeSlots;
